import { defineSlotRecipe as e } from "@pandacss/dev";
const o = e({
  className: "phone-input",
  slots: ["flagSelector", "menuContent", "menuItem", "base-input", "positioner"],
  base: {
    flagSelector: {
      width: "1rem",
      position: "relative",
      top: "1px"
    },
    positioner: {
      zIndex: "2000 !important"
    },
    menuContent: {
      bg: "neutral.50",
      borderColor: "neutral.50",
      maxHeight: "20rem",
      maxWidth: "18.75rem",
      width: "max-content",
      overflow: "scroll",
      _focusVisible: {
        outline: "none"
      }
    },
    menuItem: {
      p: "2.5",
      display: "flex",
      height: "3rem",
      alignItems: "center",
      gap: "1.5",
      _hover: {
        cursor: "pointer",
        bg: "neutral.100"
      },
      _highlighted: {
        backgroundColor: "neutral.100"
      }
    },
    "base-input": {}
  }
});
export {
  o as phoneInput
};
